import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import dayjs from 'dayjs-ext';
import { toast } from 'react-toastify';
import { Modal, ModalCard, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalBackground, Button } from 'src/ui/mui-ui-kit';
import { UiDatePickerAdapter, reduceServerErrors, UiToastAdapter } from 'src/ui';
import { getUpdateAudit } from '../redux/selectors';
import { fetchAudits, patchAudit } from '../redux/actions';

class AuditDateEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleSubmit = async (values) => {
    const { audit, field, patchAudit, fetchAudits, onClose } = this.props;
    this.setState({ loading: true });

    try {
      const updateData = {
        [field]: dayjs(values[field]).format('YYYY-MM-DD'),
      };

      await patchAudit(audit.id, updateData);

      const { auditUpdate } = this.props;
      if (auditUpdate.isError()) {
        reduceServerErrors(auditUpdate);
        return;
      }

      await fetchAudits();

      toast(UiToastAdapter('Audit date updated successfully!', 'success'));
      onClose();
    } catch (error) {
      console.error('Error updating audit date:', error);
      toast(UiToastAdapter('Error updating audit date', 'error'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { isActive, onClose, audit, field } = this.props;
    const { loading } = this.state;

    // Don't render if field is not valid
    if (!field || !audit) {
      return null;
    }

    const fieldLabel = field === 'next_audit_date' ? 'Next Audit Date' : 'Last Audit Date';
    const initialValues = {
      [field]: audit ? audit[field] : null,
    };

    return (
      <Modal isActive={isActive} onClose={onClose}>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <ModalCard>
                <ModalCardHeader>
                  <ModalCardTitle>Edit {fieldLabel}</ModalCardTitle>
                </ModalCardHeader>
                <ModalCardBody>
                  <Field
                    component={UiDatePickerAdapter}
                    name={field}
                    id={field}
                    required
                    label={fieldLabel}
                    validate={(value) => {
                      if (!value) return `${fieldLabel} is required`;
                      return undefined;
                    }}
                  />
                  <div className="buttons is-right" style={{ marginTop: '1rem' }}>
                    <Button
                      type="button"
                      className="is-text"
                      onClick={onClose}
                      disabled={submitting || loading}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      className="is-gradient-bright"
                      disabled={submitting || loading}
                    >
                      Save
                    </Button>
                  </div>
                </ModalCardBody>
              </ModalCard>
            </form>
          )}
        />
      </Modal>
    );
  }
}

AuditDateEditModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  audit: propTypes.object,
  field: propTypes.string,
  patchAudit: propTypes.func.isRequired,
  fetchAudits: propTypes.func.isRequired,
  auditUpdate: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    auditUpdate: getUpdateAudit(state),
  };
}

const connectedAuditDateEditModal = connect(mapStateToProps, {
  patchAudit,
  fetchAudits,
})(AuditDateEditModal);

export { connectedAuditDateEditModal as AuditDateEditModal };